// extracted by mini-css-extract-plugin
export default {"container":"RQ-z","error":"SQ-z","disabled":"TQ-z","submit":"UQ-z","option":"VQ-z","success":"WQ-z","failure":"XQ-z"};